module.exports = __webpack_public_path__ + "img/ivfthailand.1ecc3246.png";